import { Node, mergeAttributes } from "@tiptap/core";
import { PROPOSAL_OPTIONS_INCLUDE, isProposalOptionsText } from "./proposal_options_include.js";

// Opaque block node for the proposal options list, built like PricingTableInclude:
// an atom survives getHTML() round-trips, and the include tag is what Liquid renders.
export const ProposalOptionsInclude = Node.create({
  name: "proposalOptions",
  group: "block",
  atom: true,
  selectable: true,
  draggable: true,

  addOptions() {
    return { label: "Proposal options" };
  },

  parseHTML() {
    return [
      { tag: 'div[data-liquid-include="proposal_options"]' },
      {
        tag: "p",
        getAttrs: (el) => (isProposalOptionsText(el.textContent) ? {} : false)
      }
    ];
  },

  renderHTML() {
    return [
      "div",
      mergeAttributes({
        "data-liquid-include": "proposal_options",
        class: "liquid-proposal-options"
      }),
      PROPOSAL_OPTIONS_INCLUDE
    ];
  },

  addNodeView() {
    const label = this.options.label;
    return () => {
      const dom = document.createElement("div");
      dom.className =
        "liquid-proposal-options-card my-2 flex items-center gap-2 rounded-lg border border-dashed " +
        "border-primary-400 bg-primary-50 px-4 py-3 text-sm font-medium text-primary-800 " +
        "dark:border-primary-600 dark:bg-primary-900/20 dark:text-primary-300";
      dom.setAttribute("contenteditable", "false");
      dom.textContent = label;
      return { dom };
    };
  }
});

// A generated document holds the block itself, not the include. The schema has no div,
// so without this node a save flattens the block and the refresher cannot find it. The
// HTML is kept verbatim as an attribute and is only ever handled in an inert document:
// the stored HTML is written by whoever edited the source, and the editor runs with a
// colleague's session, so the card below stands in for it on screen.
export const ProposalOptionsBlock = Node.create({
  name: "proposalOptionsBlock",
  group: "block",
  atom: true,
  selectable: true,

  addOptions() {
    return { label: "Proposal options" };
  },

  addAttributes() {
    return {
      html: { default: "", parseHTML: (el) => el.outerHTML, rendered: false }
    };
  },

  parseHTML() {
    return [{ tag: "div[data-proposal-options]" }];
  },

  renderHTML({ node }) {
    return new DOMParser().parseFromString(node.attrs.html, "text/html").body.firstElementChild;
  },

  addNodeView() {
    const label = this.options.label;
    return () => {
      const dom = document.createElement("div");
      dom.className =
        "proposal-options-block-card my-2 flex items-center gap-2 rounded-lg border border-dashed " +
        "border-primary-400 bg-primary-50 px-4 py-3 text-sm font-medium text-primary-800 " +
        "dark:border-primary-600 dark:bg-primary-900/20 dark:text-primary-300";
      dom.setAttribute("contenteditable", "false");
      dom.textContent = label;
      return { dom };
    };
  }
});
